import React from 'react';
import styled from 'styled-components';
import Icon from '../../../../../common/Icon';
import {
  BodyFour,
  SubtitleThree
} from '../../../../../styles/theme/default/typography';

const Wrapper = styled.div`
  .value-name {
    margin-top: 8px;
    margin-bottom: 8px;
  }
`;

function Value({ valueProp, className }) {
  const { name, icon, description } = valueProp;
  return (
    <Wrapper className={className ? className : ''}>
      <Icon className={icon} icon={icon} size={30} color="black" />{' '}
      <BodyFour className="value-name hide-on-desktop">{name}</BodyFour>
      <SubtitleThree className="value-name hide-on-mobile" bold={true}>
        {name}
      </SubtitleThree>
      <BodyFour color="#4B4B4B">{description}</BodyFour>
    </Wrapper>
  );
}

export default Value;
